module.exports = __webpack_public_path__ + "static/media/pago_de_servicios.70b7ec2b.svg";